import { useMemo, useState } from 'react';

const DEFAULT_AVATAR_SRC = '/images/avatar-placeholder.svg';

function initialsFromName(name, email) {
  const base = String(name || email || '?').trim();
  const parts = base.split(/[\s@._-]+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return (parts[0]?.slice(0, 2) || '?').toUpperCase();
}

/**
 * @param {{
 *  name?: string;
 *  email?: string;
 *  imageUrl?: string | null;
 *  sizeClass?: string;
 *  className?: string;
 *  title?: string;
 *  style?: import('react').CSSProperties;
 * }} props
 */
export default function UserAvatar({
  name = '',
  email = '',
  imageUrl = null,
  sizeClass = 'h-10 w-10',
  className = '',
  title = '',
  style,
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const cleanImageUrl = typeof imageUrl === 'string' && imageUrl.trim() ? imageUrl.trim() : '';
  const src = !imgFailed && cleanImageUrl ? cleanImageUrl : DEFAULT_AVATAR_SRC;
  const initials = useMemo(() => initialsFromName(name, email), [name, email]);

  return (
    <div
      title={title || name || email}
      style={style}
      className={`relative overflow-hidden rounded-full bg-slate-100 ring-1 ring-black/5 dark:bg-slate-800 ${sizeClass} ${className}`.trim()}
    >
      <img
        src={src}
        alt={name ? `${name} avatar` : 'User avatar'}
        className="h-full w-full object-cover"
        onError={() => setImgFailed(true)}
      />
      {(!cleanImageUrl || imgFailed) && (
        <span className="pointer-events-none absolute inset-0 flex items-center justify-center bg-brand-600/90 text-xs font-semibold text-white">
          {initials}
        </span>
      )}
    </div>
  );
}
